<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <h2 class="modal-card-title">
        Overlimit users
      </h2>
      <button class="modal-close is-large" @click="onCancel"></button>
    </header>
    <section class="modal-card-body">
      <p v-if="contractors.length > 0">
        The new limit(s) is lower than the number of additional users some customers
        already have (see list).
        <b>
          Exceeding additional users will be deleted.
        </b>
      </p>
      <p v-else>
        The new limit is lower than the number of additional users the customer already has.
        <br>
        <b>
          Overlimit additional users will be deleted.
        </b>
      </p>
      <ul>
        <li v-for="contractor in contractors" :key="contractor.companyName">
          <a
              :href="'./contractors?companyName=' + encodeURIComponent(contractor.companyName)"
              target="_blank"
          >
            {{ contractor.id }} - {{ contractor.companyName }} ({{ contractor.plan.tier }})
            <i class="fal fa-arrow-circle-right"></i>
          </a>
        </li>
      </ul>
    </section>
    <footer class="modal-card-foot buttons is-right">
      <button class="button button-cancel" type="button" @click="onCancel">
        Cancel
      </button>
      <button class="button is-success" @click="onConfirm">
        continue
      </button>
    </footer>
  </div>
</template>

<script>

export default {
  name: 'MultipleUsersConfirmation',
  props: ['contractors'],
  methods: {
    onConfirm() {
      this.$emit('confirm');
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped lang="stylus">
button.button
  width 135px
  height 46px
  border 1px solid #23D160
  font-size 19px
  text-transform uppercase
.button.button-cancel
  color #23D160
.button.button-cancel:hover
  background #17b548
  color white
.button.is-success
  border none

.modal-card .modal-card-title
  font-size 30px
  font-weight 600
  margin-bottom unset

.modal-close
  top 16px

.modal-card-foot
  border none
  background-color white

p
  margin-bottom 20px
ul
  li
    display flex
    align-items center
    :not(:last-child)
      margin-bottom 10px
    a
      color #4a4a4a
      i
        color #768086
        font-size 25px
        margin-left 10px
.buttons
  @media(max-width:326px)
    flex-direction: column
    .button
      width 100%

</style>

<style lang="stylus">
.multiple-users-confirmation
  .animation-content
    width 665px
  .modal-card
    width 100% !important
  @media(max-width:1156px)
    .animation-content
      width 500px
    .modal-card
      width 100% !important
  @media(max-width:768px)
    width 100%
</style>
